<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="600"
    style="z-index: 6"
  >
    <v-form ref="editOrgUnitForm" @submit.prevent="submit">
      <v-card
        flat
        class="overflow-auto"
        :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown }"
      >
        <v-card-text v-if="orgUnitToEdit">
          <v-row class="flex-wrap justify-center">
            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    label="Naziv ustrojstvene jedinice"
                    autofocus
                    v-model="orgUnitToEdit.name"
                    class="pt-2 form-input"
                    :rules="[rules.req]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="7" class="pb-0">
                  <v-select
                    outlined
                    dense
                    label="Odaberite printer"
                    :items="printers"
                    item-text="name"
                    item-value="id"
                    v-model="orgUnitToEdit.printer"
                    class="form-input"
                  ></v-select>
                </v-col>
                <v-col cols="5">
                  <v-btn
                    x-small
                    class="mt-2"
                    style="z-index: 4"
                    bottom
                    right
                    plain
                    text
                    @click="openAddPrinter"
                  >
                    <v-icon>mdi-plus</v-icon>
                    <span>Dodaj printer</span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="7" class="pb-0">
                  <v-select
                    multiple
                    outlined
                    dense
                    label="Odaberite kategorije artikala"
                    :items="categories"
                    return-object
                    item-text="name"
                    v-model="selectedCategories"
                    class="form-input"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-5">
          <v-btn
            text
            class="btn-primary"
            height="45"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            Spremi izmjene
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <add-printer-inline ref="addPrinter"></add-printer-inline>
  </v-dialog>
</template>
<script>
import { functions, df } from '@/plugins/firebase'
import rules from '@/plugins/rules'
import AddPrinterInline from '@/modules/point-of-sale/components/printer-configuration/AddPrinterInline'
import { clone } from '@/plugins/utils'

export default {
  components: { AddPrinterInline },
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  props: {
    location: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    orgUnit: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    visible: false,
    submitting: false,
    orgUnitToEdit: undefined,
    printers: [],
    rules: {
      req: rules.req(),
      eq: rules.eq,
      arrReq: rules.arrReq()

    },
    selectedCategories: [],
    categories: [],
    sortedCategories: [],
    listeners: []
  }),
  mounted () {
    this.open(this.location.id, clone(this.orgUnit))
  },
  methods: {
    openAddPrinter () {
      this.$refs.addPrinter.open(this.location.id)
    },
    open (locationId, orgUnit) {
      const query = df
        .collection(`location_printers/${this.location.id}/printers`)
      const listener = query
        .onSnapshot((doc) => {
          doc.docs.forEach((rec) => {
            this.printers.push(rec.data())
          })
        }
        )
      this.listeners.push(listener)

      this.listeners.push(
        df
          .doc(`company_categories/${this.company.id}`)
          .onSnapshot((doc) => {
            if (
              doc &&
              doc.data() &&
              doc.data().categories &&
              Object.keys(doc.data().categories).length > 0
            ) {
              this.categories = Object.keys(doc.data().categories).map(
                (key) => {
                  return doc.data().categories[key]
                }
              )
            }
            this.sortedCategories = clone(this.categories.sort((a, b) => a.name.localeCompare(b.name)))
          })
      )

      if (orgUnit.printer && orgUnit.printer !== '') {
        this.printers.forEach(printer => {
          if (printer.id === orgUnit.printer) {
            orgUnit.printer = printer
          }
        })
      }

      this.orgUnitToEdit = orgUnit
      this.visible = true
      this.submitting = false
      this.locationId = locationId
    },
    close () {
      this.resetInputs()
      this.$emit('close')
    },
    resetInputs () {
      this.orgUnitToEdit = undefined
      this.visible = false
      this.selectedCategories = []
    },
    async submit () {
      if (!this.orgUnitToEdit) {
        return
      }
      const tblId = this.orgUnitToEdit.id
      const docRef = df.doc(`location_units/${this.locationId}/units/${tblId}`)

      const categories = this.selectedCategories.map((category) => {
        return {
          id: category.id,
          name: category.name,
          picture: category.picture
        }
      })

      if (categories && categories.length > 0) {
        const payload = {
          action: {
            operation: 'set',
            entity: 'organizational_unit',
            params: {
              organizational_unit_id: tblId,
              company_id: this.company.id,
              location_id: this.location.id,
              categories: categories
            }
          }
        }

        try {
          var companyitemApi = functions.httpsCallable('companyitemapi')

          companyitemApi({
            action: {
              operation: payload.action.operation,
              entity: payload.action.entity,
              resource_id: payload.action.resource_id,
              params: payload.action.params
            }
          })
            .then((result) => {
              if (result.data.code === 200) {

              } else {
                this.showMsgBox({
                  text: result.data.message ?? 'Dogodila se pogreška.',
                  actions: ['cancel'],
                  cancelBtnText: 'OK',
                  color: 'error'
                })
              }
            })
        } catch (err) {
          this.showMsgBox({
            text: err && err !== '' ? err : 'An error has occurred',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
        }
      }

      try {
        await docRef.set(
          {
            id: tblId,
            name: this.orgUnitToEdit.name,
            printer: this.orgUnitToEdit.printer
          }
        )
        console.log('Table successfully saved.')
      } catch (err) {
        console.error('Error saving table: ', err)
      }

      this.resetInputs()
      this.$emit('close')
    }
  }

}
</script>
<style scoped>
.form-input >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F8FAFC !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}
.btn-secondary {
  padding: 11px 20px;
  background: #F8FAFC;
  border: 1.5px solid #E2E8F0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-secondary:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
  color: #334155;
}
</style>
